import { render, staticRenderFns } from "./goal-property-section.vue?vue&type=template&id=a99aaecc"
import script from "./goal-property-section.vue?vue&type=script&lang=ts"
export * from "./goal-property-section.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports